export default __webpack_public_path__ + "static/media/materials.5a1f2584.svg";